import Swal from "sweetalert2";

/**
 * Success Alert
 */
export const successAlert = (text = "") => {
  return Swal.fire({
    icon: "success",
    title: 'Success',
    text,
    timer: 2000,
    confirmButtonText: "OK",
    confirmButtonColor: "#16a34a",
  });
};

/**
 * Error Alert
 */
export const errorAlert = (text = "") => {
  return Swal.fire({
    icon: "error",
    title: "Error",
    text,
    timer: 2000,
    confirmButtonText: "OK",
    confirmButtonColor: "#dc2626", // red
  });
};

/**
 * Warning Alert
 */
export const warningAlert = (text = "") => {
  return Swal.fire({
    icon: "warning",
    title: "Warning",
    text,
    timer: 2000,
    // confirmButtonText: "OK",
    // confirmButtonColor: "#f59e0b", 
  });
};

/**
 * Info Alert
 */
export const infoAlert = (text = "") => {
  return Swal.fire({
    icon: "info",
    title: "Info",
    text,
    timer: 2000,
    // confirmButtonText: "OK",
    // confirmButtonColor: "#2563eb",
  });
};
export const confirmAlert = (title = "Are you sure?", text = "") => {
  return Swal.fire({
    icon: "warning",
    title,
    text,
    showCancelButton: true,
    confirmButtonText: "Yes",
    cancelButtonText: "Cancel",
    confirmButtonColor: "#dc2626", // red (danger action)
    cancelButtonColor: "#6b7280", // gray
  });
};